import { Divider } from 'src/components/atoms';
import { Accordion } from 'src/components/molecules';
import { User } from 'src/types';
import { GroupMemberItem } from './GroupMemberItem';
import {
  GroupMembersContainer,
  GroupMembersEmptyState,
  GroupMembersList,
  GroupMembersTitle,
} from './GroupMembers.styles';

interface Props {
  members: User[];
  groupId: string;
  isLoading?: boolean;
}

export const GroupMembers = ({ members, groupId, isLoading }: Props) => (
  <GroupMembersContainer
    data-testid={`group-accordion-children-container-${groupId}`}
  >
    <Divider variant="horizontal" height="auto" />
    <Accordion
      title={<GroupMembersTitle>Group members</GroupMembersTitle>}
      defaultOpen={false}
      topBorder
      bottomBorder
      topBorderRadius="0"
      bottomBorderRadius="0"
      hideContentBorder
      data-testid={`group-members-accordion-${groupId}`}
    >
      {!isLoading && members.length === 0 ? (
        <GroupMembersEmptyState
          data-testid={`group-members-empty-state-${groupId}`}
        >
          No members
        </GroupMembersEmptyState>
      ) : (
        <GroupMembersList>
          {members.map((member, index) => (
            <GroupMemberItem
              key={member.id ?? `${member.email}-${index}`}
              member={member}
              data-testid={`group-member-${groupId}-${member.id ?? index}`}
            />
          ))}
        </GroupMembersList>
      )}
    </Accordion>
  </GroupMembersContainer>
);
